/** Get Dashboard Chart data */
export const API_SUCCESS = 'API_SUCCESS'
export const API_FAIL = 'API_FAIL'
export const GET_CHARTS_DATA = 'GET_CHARTS_DATA'
